// El campo `country` del lead es texto libre, asi que normalizamos (minusculas,
// sin acentos) antes de buscar el gentilicio.
const NATIONALITIES = {
  espana: "ESPAÑOLA",
  colombia: "COLOMBIANA",
  mexico: "MEXICANA",
  argentina: "ARGENTINA",
  peru: "PERUANA",
  chile: "CHILENA",
  venezuela: "VENEZOLANA",
  ecuador: "ECUATORIANA",
  bolivia: "BOLIVIANA",
  uruguay: "URUGUAYA",
  paraguay: "PARAGUAYA",
  brasil: "BRASILEÑA",
  brazil: "BRASILEÑA",
  panama: "PANAMEÑA",
  "costa rica": "COSTARRICENSE",
  guatemala: "GUATEMALTECA",
  honduras: "HONDUREÑA",
  nicaragua: "NICARAGÜENSE",
  "el salvador": "SALVADOREÑA",
  "republica dominicana": "DOMINICANA",
  cuba: "CUBANA",
  "puerto rico": "PUERTORRIQUEÑA",
  "estados unidos": "ESTADOUNIDENSE",
  usa: "ESTADOUNIDENSE",
  eeuu: "ESTADOUNIDENSE",
  canada: "CANADIENSE",
  italia: "ITALIANA",
  francia: "FRANCESA",
  portugal: "PORTUGUESA",
  alemania: "ALEMANA",
  "reino unido": "BRITÁNICA",
  inglaterra: "BRITÁNICA",
  suiza: "SUIZA",
  "paises bajos": "NEERLANDESA",
  holanda: "NEERLANDESA",
  belgica: "BELGA",
  andorra: "ANDORRANA",
};

/**
 * Devuelve el gentilicio en femenino (concuerda con "de nacionalidad ...").
 * Si el pais no esta mapeado, devuelve el propio pais en mayusculas para que el
 * admin lo corrija a mano en vez de dejar el campo vacio.
 */
export function nationalityFromCountry(country) {
  if (!country) return "";
  const key = String(country)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return NATIONALITIES[key] || String(country).trim().toUpperCase();
}
